module.exports = __webpack_public_path__ + "img/img07.345fc430.svg";